import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
}), 'VolumeDownSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VolumeDownSharp.js
// module id = 7163
// module chunks = 2